import React from 'react';
import { Link } from 'react-router-dom';
import { useCompareStore, useCartStore } from '../store';
import { toast } from 'react-toastify';
import './Compare.css';

const ATTRS = [
  ['Price',          p => `$${(p.salePrice || p.price).toFixed(2)}`],
  ['Purity',         p => p.purity || '≥99%'],
  ['Category',       p => p.category],
  ['Molecular Wt',   p => p.molecularWeight ? `${p.molecularWeight} g/mol` : 'N/A'],
  ['In Stock',       p => p.stock > 0 ? `Yes (${p.stock})` : 'No'],
  ['Rating',         p => `${'★'.repeat(Math.round(p.rating || 0))} (${p.reviewCount || 0})`],
];

export default function Compare() {
  const { items, remove, clear } = useCompareStore();
  const { addItem } = useCartStore();

  if (items.length === 0) return (
    <div className="wishlist-empty">
      <div style={{ fontSize: '3rem' }}>⚖️</div>
      <h2>Nothing to compare</h2>
      <p>Add up to 4 products to compare their specifications side-by-side.</p>
      <Link to="/shop" className="btn btn-primary btn-lg">Browse Products</Link>
    </div>
  );

  return (
    <div className="container" style={{ padding: '2.5rem 0 4rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <h1 style={{ fontSize: '1.75rem', fontWeight: 800 }}>Compare Products</h1>
        <button className="btn btn-secondary btn-sm" onClick={clear}>Clear All</button>
      </div>
      <div className="compare-table-wrap card">
        <table className="compare-table">
          <thead>
            <tr>
              <th style={{ width: 180 }}>Feature</th>
              {items.map(p => (
                <th key={p.id}>
                  <div className="compare-product-header">
                    <button className="compare-remove" onClick={() => remove(p.id)}>✕</button>
                    <img src={p.images?.[0] || 'https://placehold.co/120x90?text=P'} alt={p.name} />
                    <Link to={`/shop/${p.slug}`}>{p.name}</Link>
                    <button className="btn btn-primary btn-sm" onClick={() => { addItem(p, 1); toast.success('Added to cart!'); }}>Add to Cart</button>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ATTRS.map(([label, fn]) => (
              <tr key={label}>
                <td className="compare-label">{label}</td>
                {items.map(p => <td key={p.id}>{fn(p)}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
